import React, { useState } from 'react';
import { View, Pressable } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faCopy, faEye } from '@fortawesome/free-solid-svg-icons';

import Modal from 'app/src/elements/Modal';
import { Text } from 'app/src/styles';
import { CellText } from 'app/src/styles/table';

export const FullToken = ({ accessToken }) => {
  const [clipboardWriteAt, setClipboardWriteAt] = useState();

  const addToClipboard = () => {
    navigator.clipboard.writeText(accessToken.token);
    setClipboardWriteAt(new Date().getTime());
  };

  return (
    <View style={{ flexDirection: 'row', gap: 12 }}>
      <CellText>{accessToken.token}</CellText>
      <Pressable onPress={addToClipboard}>
        <FontAwesomeIcon
          icon={faCopy}
          title="Copy to Clipboard"
          color={
            (clipboardWriteAt &&
              clipboardWriteAt + 5000 > new Date().getTime()
            ) ?  'green' : 'black'
          }
        />
      </Pressable>
    </View>
  );
};

const Token = ({ accessToken }) => {
  const [showToken, setShowToken] = useState(false);

  let title = 'API Access Token'
  if (accessToken.name) {
    title = `${title} - ${accessToken.name}`;
  }

  return (
    <View style={{ flexDirection: 'row', gap: 12 }}>
      <CellText>{accessToken.token.substr(0, 5)}...</CellText>
      {accessToken.isViewable && (
        <Pressable onPress={() => setShowToken(true)}>
          <FontAwesomeIcon icon={faEye} color="green" />
        </Pressable>
      )}

      {showToken && (
        <Modal title={title} setShow={setShowToken}>
          <FullToken accessToken={accessToken} />
        </Modal>
      )}
    </View>
  )
};

export default Token;
